<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="chapter">
<p class="h1" id="d7e902332" style="color: #82a339"><b>PERFECT GUACAMOLE</b></p>
<p class="extc" id="d7e902832"><a href="#/Text/West_9781618371621_epub_c8_r1#d7e809428" id="d14e2683"> (Pictured) </a></p>
<p class="ext" id="d7e903332"><b><i>Our favorite avocados for guacamole are the varieties with thick, pebbly, green skin such as Hass, Pinkerton, and Reed. While guacamole is usually served as a dip, it is also a great accompaniment for fajitas or tacos.</i></b></p>
<p class="h4" id="d7e904932" style="color: #496210"><b>Prep: 15 minutes</b></p>
<p class="ul" id="d7e905432">1 jalapeño chile, seeded and finely chopped</p>
<p class="ul" id="d7e905732">⅓ cup loosely packed fresh cilantro leaves, chopped</p>
<p class="ul" id="d7e906632">¼ cup finely chopped sweet onion such as Vidalia or <br/> Maui</p>
<p class="ul" id="d7e907932">½ teaspoon salt</p>
<p class="ul" id="d7e908832">2 ripe avocados</p>
<p class="ul" id="d7e909132">1 plum tomato <br/> plain tortilla chips</p>
<p class="pub" id="d7e910132" style="margin-top: 1.5em;"><span style="color: #c15b49"><b>1.</b></span> In mortar, combine jalapeño, cilantro, onion, and salt; with pestle, grind until mixture becomes juicy and thick (onion can still be slightly chunky).</p>
<p class="pub" id="d7e911432"><span style="color: #c15b49"><b>2.</b></span> Cut each avocado lengthwise in half around seed. Twist halves in opposite directions to separate. Slip spoon between pit and fruit and work pit out. With spoon, scoop fruit from peel onto cutting board.</p>
<p class="pub" id="d7e913432"><span style="color: #c15b49"><b>3.</b></span> Cut tomato crosswise in half. Squeeze halves to remove seeds and juice. Coarsely chop tomato.</p>
<p class="pub" id="d7e914432"><span style="color: #c15b49"><b>4.</b></span> If mortar is large enough, add avocado and chopped tomato to onion mixture in mortar. (If mortar is small, combine avocado, tomato, and onion mixture in bowl.) Mash slightly with pestle or spoon until mixture is blended but still somewhat chunky.</p>
<p class="pub" id="d7e916432"><span style="color: #c15b49"><b>5.</b></span> Guacamole is best when served as soon as it’s made. If not serving right away, press plastic wrap directly onto surface of guacamole to prevent discoloration and refrigerate up to 1 hour. Serve with chips. Makes about 1¾ cups.</p>
<p class="ntx" id="d7e919732">Each tablespoon: About 25 calories, 0g protein, 1g carbohydrate, 2g total fat (0g saturated), 0mg cholesterol, 45mg sodium.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// West_9781618371621_epub_c14_r1.vue?1932ceb8